<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <p class="text-2xl font-bold text-center">
        Purchase "{{ selectedContent.name }}" for ${{ selectedContent.cost.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2 }) }}?
      </p>
      <div class="pt-8 flex justify-center">
        <div id="paypal-button-container" class="w-full md:w-1/2" />
      </div>
    </section>
    <footer class="modal-card-foot justify-end">
      <d-btn flat @click="$parent.close()">
        Cancel
      </d-btn>
      <d-btn :loading="saving" disabled>
        Buy Now
      </d-btn>
    </footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import { useAuthStore } from '@stores/auth';

  export default {
    props: {
      selectedContent: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        saving: false,
        orderForm: {
          contentListingId: this.selectedContent.id,
          paymentToken: '',
        },
        auth: null,
      };
    },

    computed: {
      profile() {
        return this.auth ? this.auth.profile || {} : {};
      },
      loggedIn() {
        return this.auth ? this.auth.loggedIn : false;
      },
      canContinue() {
        return !!this.orderForm.paymentToken;
      },
    },

    mounted() {
      this.auth = useAuthStore();
      this.$nextTick(() => {
        this.setupPaypal();
      });
    },

    methods: {
      async purchase() {
        this.saving = true;
        try {
          const { data: createPurchaseResult } = await axios.post('/api/purchases', this.orderForm);
          await axios.post(`/api/purchases/${createPurchaseResult.resultObject.id}/submit`);
          this.$toast.success('Purchase was successful!');
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } catch (error) {
          this.$toast.error(error.response.data[0]);
          this.saving = false;
        }
      },

      setupPaypal() {
        const vm = this;
        // eslint-disable-next-line no-undef
        paypal.Buttons({
          style: {
            layout: 'vertical',
            color: 'blue',
            shape: 'rect',
            label: 'paypal',
          },
          createOrder(data, actions) {
            // Set up the transaction
            return actions.order.create({
              enableStandardCardFields: true,
              payer: {
                name: {
                  given_name: vm.profile.firstName,
                  surname: vm.profile.lastName,
                },
                email_address: vm.profile.email,
              },
              purchase_units: [{
                amount: {
                  value: vm.selectedContent.cost,
                },
              }],
            });
          },
          async onApprove(data) {
            vm.orderForm.paymentToken = data.orderID;
            vm.purchase();
          },
        }).render('#paypal-button-container');
      },
    },
  };
</script>